import { ENDPOINTS } from "../../apiConfig";
import { showToast } from "../../../components";
import axiosRequest from "../universal/axiosService";

// export const fetchAllDocuments = async (params) => {
//   try {
//     const token = localStorage.getItem("token");

//     const response = await axios.get(ENDPOINTS.DOCUMENT.GET_ALL, {
//       params: {
//         coll: "Document",
//         lim: 100,
//         pg: 1,
//         fil: JSON.stringify(params.fil),
//         cache: params.cache,
//       },
//       headers: {
//         Authorization: `Bearer ${token}`, // Add authorization header
//         "Content-Type": "application/json",
//       },
//       withCredentials: true, // Include cookies if using session-based auth
//     });
//     return response.data;
//   } catch (error) {
//     console.error(error);
//     //throw error;
//     // showToast("No Data available", "error", 5000);
//   }
// };
export const fetchAllDocuments = async (params) => {
  // const filter = {
  //   [params.type]: {
  //     type: "NONE",
  //     value: params.uiid,
  //   },
  // };
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.DOCUMENT.GET_ALL,
    params: {
      coll: "Document",
      lim: 100,
      pg: 1,
      fil: JSON.stringify(params?.filter),
      cache: params.cache,
    },
  });
};

// export const fetchAllDocuments = async (params) => {
//   console.log('params',params);
//   try {
//      const filter = {
//     [params.type]: {
//       type: "NONE",
//       value: params.uiid,
//     },
//   };
//     // Make both API calls concurrently using axiosRequest
//     const [documentResponse, totalCountResponse] = await Promise.all([
//      axiosRequest({
//     method: "GET",
//     url: ENDPOINTS.DOCUMENT.GET_ALL,
//     params: {
//       coll: params.coll,
//       lim: 10,
//       pg: 1,
//       fil: JSON.stringify(filter),
//       cache:params.cache,
//     },
//   }),
//      await axiosRequest({
//   method: "GET",
//  url: `${ENDPOINTS.GET_TOTAL_COUNT}/${params.coll.toLowerCase()}s/getTotalCount`,
//   params: {
//     coll: params.coll,
//     fil: JSON.stringify(filter),
//   },
// })
//     ]);
//     return {
//        success: true,
//       data: documentResponse.data,
//       totalCount: totalCountResponse.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//     throw error;
//   }
// };

export const addW4FormDocuments=async(payload)=>{
  return await axiosRequest({
     method: "POST",
     url:ENDPOINTS.DOCUMENT.ADD_TAXFORM,
     data:payload
  })
}
export const fetchAllTaxFormDocuments = async (params) => {
  const { fil, ...rest } = params;

  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.DOCUMENT.GET_ALL_TAXFORM,
    params: {
      ...rest,
      fil: JSON.stringify(fil), // ✅ stringify the `fil` object
    },
  });
};
